/* ==========================================================================
   BGC Story assets — shared script for:
     sections/bgc-use-cases.liquid  (no JS needed — CSS-only hover/zoom)
     sections/bgc-reviews.liquid    (drifting testimonial rail)
     sections/bgc-faq.liquid        (accordion)
   Owned by AGENT-STORY. Ported from redesign/js/main.js.
   GSAP/ScrollTrigger + the global reveal system + window.BGC.driveTrack are
   provided by bgc-core.js (AGENT-BASE); this file guards for their presence
   and falls back to plain rAF/CSS behavior when absent.
   ========================================================================== */
(function () {
  "use strict";

  /* ---------- Reviews: drifting testimonial rail ---------- */

  /* Local rAF fallback, mirrors core's whole-pixel driver, used only if
     window.BGC.driveTrack isn't available (e.g. bgc-core.js not loaded yet). */
  function fallbackDriveTrack(track, pxPerSec) {
    var x = 0, paused = false, half = 0, prev = 0;

    function measure() {
      half = track.scrollWidth / 2;
    }
    measure();
    window.addEventListener("resize", measure);
    track.addEventListener("mouseenter", function () { paused = true; });
    track.addEventListener("mouseleave", function () { paused = false; });

    function tick(now) {
      if (!prev) prev = now;
      var dt = now - prev;
      prev = now;
      if (!paused && half) {
        x -= pxPerSec * (dt / 1000);
        if (-x >= half) x += half;
        track.style.transform = "translate3d(" + Math.round(x) + "px,0,0)";
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  document.querySelectorAll("[data-bgc-reviews-track]").forEach(function (track) {
    if (!track) return;
    var speed = parseFloat(track.getAttribute("data-speed")) || 55;
    /* Build a selector scoped to this exact track instance so multiple
       bgc-reviews sections on one page each get their own driver. */
    var selector = null;
    track.classList.forEach(function (cls) {
      if (cls.indexOf("bgc-reviews-track-") === 0) selector = "." + cls;
    });

    if (window.BGC && typeof window.BGC.driveTrack === "function" && selector) {
      window.BGC.driveTrack(selector, speed);
    } else {
      fallbackDriveTrack(track, speed);
    }
  });

  /* ---------- FAQ: accordion, one open at a time, smooth max-height ---------- */

  document.querySelectorAll("[data-bgc-faq]").forEach(function (list) {
    var items = list.querySelectorAll(".bgc-faq-item");

    items.forEach(function (item) {
      var q = item.querySelector(".bgc-faq-q");
      var a = item.querySelector(".bgc-faq-a");
      if (!q || !a) return;

      q.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");

        items.forEach(function (other) {
          if (other === item) return;
          other.classList.remove("is-open");
          other.querySelector(".bgc-faq-q").setAttribute("aria-expanded", "false");
          other.querySelector(".bgc-faq-a").style.maxHeight = "0px";
        });

        if (isOpen) {
          item.classList.remove("is-open");
          q.setAttribute("aria-expanded", "false");
          a.style.maxHeight = "0px";
        } else {
          item.classList.add("is-open");
          q.setAttribute("aria-expanded", "true");
          a.style.maxHeight = a.scrollHeight + "px";
        }
      });
    });

    /* Keep the open item's max-height correct across viewport/content
       reflows (e.g. font load, resize). */
    window.addEventListener("resize", function () {
      var open = list.querySelector(".bgc-faq-item.is-open .bgc-faq-a");
      if (open) open.style.maxHeight = open.scrollHeight + "px";
    });
  });
})();
